import script from "./SpendingPlanPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpendingPlanPage.vue?vue&type=script&setup=true&lang=ts"

import "./SpendingPlanPage.vue?vue&type=style&index=0&id=8bd4b1a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bd4b1a8"]])

export default __exports__